import { Link } from "react-router-dom";
import DogImage from "@/components/DogImage";
import { useAuth } from "@/context/AuthContext";
import { Heart, LogIn } from "lucide-react";

export default function Favorites() {
  const { user, favorites, login, toggleFavorite } = useAuth();

  if (!user) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center p-10 rounded-3xl" style={{ backgroundColor: "#F7ECD9" }}>
          <Heart size={40} color="#E27E4E" fill="#E27E4E" className="mx-auto mb-4" />
          <h1 className="font-serif text-3xl mb-3" style={{ color: "#0E5C6E" }}>Save your favorite pups</h1>
          <p className="mb-6 text-sm" style={{ color: "#2D2B2A" }}>
            Sign in with Google to build a favorites list. When new dogs come in that match your style, you'll have them saved.
          </p>
          <button className="btn-primary" onClick={login} data-testid="favorites-login">
            <LogIn size={16} /> Sign in with Google
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <section className="pt-20 pb-12" style={{ backgroundColor: "#F7ECD9" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] mb-4" style={{ color: "#E27E4E" }}>Your ʻohana watch list</div>
          <h1 className="font-serif text-5xl md:text-6xl mb-4" style={{ color: "#0E5C6E" }}>My Favorites</h1>
          <p className="text-lg" style={{ color: "#2D2B2A" }}>Aloha, {user.name.split(" ")[0]}. Here are the pups you're keeping an eye on.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {favorites.length === 0 ? (
            <div className="text-center py-16" data-testid="favorites-empty">
              <Heart size={40} className="mx-auto mb-4 opacity-40" color="#0E5C6E" />
              <p className="mb-6" style={{ color: "#6B655E" }}>No favorites yet. Head to the adopt page and tap the heart on any pup you love.</p>
              <Link to="/adopt" className="btn-primary">Meet our dogs <Heart size={14} fill="white" /></Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {favorites.map((d) => (
                <div key={d.id} className="card-dog relative" data-testid={`fav-card-${d.name.toLowerCase()}`}>
                  <button
                    onClick={() => toggleFavorite(d.id)}
                    className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full flex items-center justify-center bg-white/95 shadow"
                    aria-label="Remove favorite"
                    data-testid={`fav-remove-${d.name.toLowerCase()}`}
                  >
                    <Heart size={18} fill="#E27E4E" color="#E27E4E" />
                  </button>
                  <Link to={`/adopt#${d.id}`}>
                    <div className="aspect-[4/5] overflow-hidden">
                      <DogImage dog={d} />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="font-serif text-2xl" style={{ color: "#0E5C6E" }}>{d.name}</h3>
                        <span className={`badge badge-${d.featured ? "urgent" : d.status}`}>
                          {d.featured ? "Urgent" : d.status}
                        </span>
                      </div>
                      <div className="text-sm" style={{ color: "#6B655E" }}>{d.breed} • {d.age} • {d.sex}</div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
